/**
 * 获取类名前缀
 * @param val 类名
 * @param prefix 前缀，默认为 "AdComponent_"
 */
export const getPrefixCls = (val: string, prefix?: string): string => (prefix ? prefix : "AdComponent_") + val
